<footer class="footer">
  <p class="footer__text">© V POINT MARKETING Co.,Ltd.</p>
</footer>
